<template>
    <div class="col-sm-12 col-xl-6">
        <div class="card">
            <div class="card-header pb-0">
                <h3>Checkbox Tree</h3>
            </div>
            <div class="card-body">
                <div id="treecheckbox">
                    <Tree :nodes="menu" :use-icon="false" :use-checkbox="true" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Tree from "vue3-tree";
import "vue3-tree/dist/style.css"
import treeMixin from "@/mixins/treeMixin"
export default {
    mixins: [treeMixin],
    components: {
        Tree
    },

}
</script>